import * as React from 'react'
import {Link} from "gatsby";

const Overlay = () => {
    return (
        <div className="ort">
            <div className="information">
                <div className="image" id="image">
                    <img alt="" className="ort-img dummy" src={"/images/Logo_ODD.svg"}/>                
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            München   
                        </h2>
                    </div>
                </div>
                <p>
Auszeichnung für die Frauenstimmrechtsbewegung um 1900, deren Forderung mit der Bamberger Verfassung von 1919 erfüllt wurde. Die Prinzensäle im Café Luitpold waren Versammlungsort des Frauenstimmrechtskongresses von 1912.</p>
            </div>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                Mehr erfahren
            </Link>

        </div>
    )
}

export default Overlay

